import React, { useState, useEffect, useLayoutEffect, useRef, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import useRequireAuth from "../../../utils/useRequireAuth";
import AddEditNotesData from "./ViewNotesData";
import { deleteNotes, saveNotes } from "../../../utils/customer/customerNotesSlice";
import { BASE_URL, CUSTOMER_NOTES_ADD_UPDATE } from "../../../utils/constants";

import { useFetchCustomerNotesColorDataQuery, useFetchCommonDataQuery } from "../../../utils/customer/customerSelect";
import { CUSTMOER_NOTES_ATTACHMENT_DATA_GET } from "../../../utils/constants";
import { deleteData } from "../../store/customer/CustomerSocialAddUpdateFunction";

import { getFormatDate } from "../../../utils/utilityFunctions/dateUtility";
import { pushAlert } from "../../../utils/alertSlice";

import { ReactComponent as NoNotesIcon } from "../../../assets/images/NoNotesIcon.svg";
import {
  getFormData,
  getHexWithOpacity,
  getInitials,
  getTitleCase,
} from "../../../utils/utilityFunctions/stringUtility";
import { ReactComponent as ArchiveGreyIcon } from "../../../assets/images/icons/ArchieveGreyIcon.svg";
import { ReactComponent as DeleteSolidicon } from "../../../assets/images/NewDelete.svg";
import { ReactComponent as EditSolidicon } from "../../../assets/images/icons/EditUnderLine.svg";
import { hideLoader, showLoader } from "../../../utils/loaderSlice";
import { ReactComponent as LatestPinUnpin } from "../../../assets/images/icons/LatestPinUnpin.svg";
import ConfirmationDialog from "../../UniversalComponents/ConfirmationDialogMulti";
import AvatarName from "../../UniversalComponents/AvatarName";
import {
  useAddUpdateNotesMutation,
  useDeleteNoteAttachmentMutation,
  useDeleteNoteMutation,
  usePostApiMutation,
  usePostNoteAttachmentMutation,
} from "../../../utils/customer/customerTaskTable";
import { red } from "@mui/material/colors";

import withPortalHOC from "../../UniversalComponents/WithPortalHOC.js";
import List from "../../UniversalComponents/ListComponent.js";
import { ReactComponent as DownArrow } from "../../../assets/images/downArrow.svg";
import DatePickerComponent from "../../UniversalComponents/DatePickerComponent.js";
import moment from "moment";
import SelectComponent from "../../UniversalComponents/SelectComponent";
import LabelComponent from "../../UniversalComponents/LabelComponent";
import LoaderWrapper from "../../UniversalComponents/CustomLoader";
import { Dialog } from "@mui/material";
import { ReactComponent as Share } from "../../../assets/images/icons/Share.svg";
import { getUserDateTime } from "../../../utils/utilityFunctions/UTCFormat";
import Button from "../../UniversalComponents/DefaultButton";
import { ReactComponent as AddTask } from "../../../assets/images/AddtaskComponent.svg";
import { ReactComponent as AddNotesTask } from "../../../assets/images/icons/AddNoteTask.svg";
import ToolTipComponent from "../../UniversalComponents/ToolTipComponent";

const AllNotesShow = ({
  disable,
  refreshKey,
  searchTerm,
  handlePinned,
  customerColor,
  fetchedNotesData,
  RefetchNoteData,
  setSelectedOptions,
  selectedOptions,
  sectionType,
  selectedContent,
  setSelectedContent,
  selectedDate,
  setSelectedDate,
  selectedList,
  setSelectedList,
  DaysToFollowUp,
  isCreateTask = false,
  setIsCreateTask,
  handleCreateTask = () => null,
  showLoaderInBox = true,
  propTemplateId = null,
  handleAddNotesClick,
  disableAddMode = false,
}) => {
  const { token } = useRequireAuth();
  const dispatch = useDispatch();
  const textareaRef = useRef(null);
  const { id: customerId } = useParams();
  const [editNoteId, setEditNoteId] = useState(null);
  const [refreshKeys, setRefreshKeys] = useState(0);
  const [notesData, setNotesData] = useState([]);
  const prevScrollY = useRef(0);
  const [loading, setLoading] = useState(false);
  const [viewNotes, setViewNotes] = useState({
    allnotes: false,
    addnotes: false,
  });
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [formData, setFormData] = useState({
    notes_title: "",
    notes_category_id: "",
    colour_code: "",
  });
  const [notesBody, setNotesBody] = useState(null);
  const notesDatasFormSubmit = useSelector((state) => state.notes);
  const companyLocalData = localStorage.getItem("company_data");
  const parsedCompanyData = JSON.parse(companyLocalData);
  const [visible, setVisible] = useState(true);
  const [color, setColor] = useState(null);
  const [page, setPage] = useState(1);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [deleteNotesData, setDeleteData] = useState(false);
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });
  // const [darkColor, setDarkColor] = useState('');

  const PortalList = withPortalHOC(List);
  const to_doRef = useRef(null);
  const dateRef = useRef(null);
  const listRef = useRef(null);

  const [isAddToDoChecked, setIsAddToDoChecked] = useState(false);
  const [showViewList, setShowViewList] = useState(false);
  const [DateViewContent, setDateViewContent] = useState(false);
  const [ListViewContent, setListViewContent] = useState(false);
  const [isCustomDateView, setIsCustomDateView] = useState(false);

  const handleCheckboxAdd = (id, isAddToDoChecked) => {
    setIsAddToDoChecked(isAddToDoChecked ? id : null);
  };

  // const [isCreateTask, setIsCreateTask] = useState(false);

  const handleCheckboxChange = (e, noteID) => {
    setIsCreateTask(e.target.checked);
    setIsAddToDoChecked(e.target.checked ? noteID : null);
    e.target.blur();
  };

  const handleSelectContent = (selected) => {
    setSelectedContent(selected?.value); // store only value
    setShowViewList(false);
  };

  const TaskToDoData = [
    { label: "Task", value: "task" },
    { label: "Deal", value: "deal" },
    { label: "Lead", value: "lead" },
  ];

  const OptionData = [
    { label: "Wild Card C. Inc <Task name 1>", value: "Wild Card C. Inc <Task name 1>" },
    { label: "Wild Card C. Inc <Task name 2>", value: "Wild Card C. Inc <Task name 2>" },
    { label: "Wild Card C. Inc <Task name 3>", value: "Wild Card C. Inc <Task name 3>" },
    { label: "Wild Card C. Inc <Task name 4>", value: "Wild Card C. Inc <Task name 4>" },
  ];

  const handleCustomViewClick = () => {
    setDateViewContent(false);
    setIsCustomDateView(true);
  };

  const selectedDateOption = DaysToFollowUp.find((item) => item.value === selectedDate);
  // console.log(selectedDateOption, "selectedDateOption");

  const handleSelectDate = (selectedOption) => {
    setSelectedDate(selectedOption?.value); // { label, value }
  };

  const handleDateChange = (date) => {
    const formatted = moment(date).format("DD MMM YYYY");
    setSelectedDate(formatted);
    // setIsCustomDateView(false);
  };

  const [
    deletenote,
    { data: NotesDeleteData, isError: NotesDeleteError, isSuccess: NotesDeleteSuccess, isLoading: NotesDeleteLoading },
  ] = useDeleteNoteMutation();

  const [
    AddUpdateNotes,
    {
      data: NotesAddUpdateData,
      isError: NotesAddUpdateError,
      isSuccess: NotesAddUpdateSuccess,
      isLoading: NotesAddUpdateLoading,
    },
  ] = usePostApiMutation();

  useEffect(() => {
    if (fetchedNotesData) {
      setNotesData(fetchedNotesData || []);
      setLoading(false);
    }
  }, [fetchedNotesData]);

  useEffect(() => {
    {
      RefetchNoteData().then((response) => {
        if (response?.data?.data?.notes?.length > 0) {
          setNotesData(response.data.data);
        }
      });
      setLoading(false);
    }
  }, [page, token, notesDatasFormSubmit.notes]);

  useEffect(() => {
    if (loading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [loading]);

  useEffect(() => {
    //loading
    if (NotesDeleteLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
    //try block
    if (NotesDeleteSuccess) {
      dispatch(
        pushAlert({
          message: NotesDeleteData.message,
          type: NotesDeleteData.success ? "success" : "danger",
          visible: true,
        })
      );
      if (NotesDeleteData.success) {
        refreshKey((prev) => prev + 1);
      }
    }
    // catch block
    if (NotesDeleteError) {
      dispatch(pushAlert({ message: NotesDeleteData?.message, type: "danger", visible: true }));
    }
  }, [NotesDeleteError, NotesDeleteSuccess, NotesDeleteLoading]);

  // edit function of notes
  const handleNotesEdit = (id, notesbody, attachment, title, category_name, tags) => {
    setFormData({
      notes_title: title,
      category_name: category_name,
    });
    setEditNoteId(id);
    setViewNotes({ allnotes: true, addnotes: true });
    setNotesBody(notesbody);
    setSelectedFiles(attachment);
    setSelectedOptions(tags ? tags : []);
    setVisible(false);
  };

  const handleDeleteConfirmation = (note) => {
    setDeleteData(note.id);
    setShowConfirmation(note?.notes_title);
  };

  const handleDelete = async (id) => {
    setShowConfirmation(false);
    try {
      deletenote(id);
    } catch (error) {
      dispatch(pushAlert({ message: error?.message || "Error deleting note", type: "error", visible: true }));
      console.error("Error deleting note:", error);
    }
  };

  const handleNotesClick = (key) => {
    setViewNotes((prevState) => ({ ...prevState, [key]: true }));
  };

  const hndleCloseNotes = () => {
    textareaRef.current.value = "";
    setViewNotes({ allnotes: false, addnotes: false });
    setEditNoteId(null);
    setVisible(true);
  };

  const downloadFile = async (file) => {
    const url = `${file}`;

    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSetColour = (colour) => setColor(colour);

  useEffect(() => {
    //loading
    if (NotesAddUpdateLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
    //try block
    if (NotesAddUpdateSuccess) {
      dispatch(
        pushAlert({
          message: NotesAddUpdateData.success ? NotesAddUpdateData?.msg : "something went wrong",
          type: NotesAddUpdateData.success ? "success" : "danger",
          visible: true,
        })
      );

      if (NotesAddUpdateData.success) {
        RefetchNoteData().then((response) => {
          if (response?.data?.data?.notes?.length > 0) {
            setNotesData(response.data.data);
          }
        });
        setFormData({ notes_title: "", notes_category_id: "", colour_code: "" });
        hndleCloseNotes();
        setEditNoteId(null);
        setVisible(true);
        setSelectedFiles([]);
      }
    }
    // catch block
    if (NotesAddUpdateError) {
      dispatch(pushAlert({ message: NotesAddUpdateData?.message, type: "danger", visible: true }));
    }
  }, [NotesAddUpdateLoading, NotesAddUpdateSuccess, NotesAddUpdateError]);

  const handleSubmit = (e, note) => {
    e.preventDefault();

    const notesData = {
      notes_category_id: formData.notes_category_id,
      colour_code: color,
      notes_title: e.target.notes_title.value,
      company_id: parsedCompanyData.company_id,
      customer_id: customerId,
      notes_body: textareaRef.current?.innerHTML || notesBody,
      rag_status: "wip",
      is_pinned: Boolean(note.is_pinned),
      id: editNoteId,
      attachmentIds: selectedFiles.map((file) => file.id),
      tags: selectedOptions,
    };

    const formDataNotes = getFormData(notesData); // its provide the form data formate

    try {
      if (textareaRef.current?.innerHTML !== "") {
        AddUpdateNotes({
          data: notesData,
          url: `${CUSTOMER_NOTES_ADD_UPDATE}?${propTemplateId ? `template_id=${propTemplateId}` : `type=${sectionType}`}`,
        });
      }
    } catch (error) {
      dispatch(pushAlert({ message: error?.message || "Error saving note", type: "error", visible: true }));
    }
  };

  const { data: customerTaskCategory, error, isLoading: commonDataLoading } = useFetchCommonDataQuery();

  const resetFile = (newSelectedFiles = []) => setSelectedFiles(newSelectedFiles);

  const [deleteNoteAttachment] = useDeleteNoteAttachmentMutation();

  const handleDeleteFileServer = async (id, editNoteId) => {
    try {
      const newSelectedFiles = selectedFiles.filter((f) => f.id !== id);
      resetFile(newSelectedFiles);
      const response = await deleteNoteAttachment({ id }).unwrap();
      if (response.status || response?.success || response?.data?.success || response?.data?.status) {
        dispatch(pushAlert({ message: "File deleted successfully", type: "success", visible: true }));
        setViewNotes({ allnotes: true, addnotes: true });
        setEditNoteId(editNoteId);
      }
    } catch (error) {
      dispatch(pushAlert({ message: error?.message || "Error deleting file", type: "error", visible: true }));
      console.error("Error deleting file:", error);
    }
  };

  const handleClickDeleteFile = (index) => {
    if (index >= 0 && index < selectedFiles?.length) {
      resetFile(selectedFiles.filter((file, idx) => idx !== index));
    }
  };

  const [
    postNoteAttachment,
    {
      isLoading: postNoteAttachmentLoading,
      isSuccess: postNoteAttachmentSuccess,
      isError: postNoteAttachmentError,
      data: postNoteAttachmentData,
    },
  ] = usePostNoteAttachmentMutation();

  const handleFileUpload = async () => {
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = true;
    input.click();

    input.addEventListener("change", async (event) => {
      const files = Array.from(event.target.files);
      let updatedFiles = [...selectedFiles];
      let lastId = selectedFiles.length > 0 ? selectedFiles[selectedFiles.length - 1].id : 0;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const formData = new FormData();
        formData.append("file", file);

        try {
          const response = await postNoteAttachment({ data: formData }).unwrap();

          updatedFiles.push({
            id: response.id,
            attachment: response.filename,
            file: file,
            view_url: response.view_url,
            download_url: response.download_url,
            // uploaded_id: response.id, // optional if you want to track server id
          });
        } catch (error) {
          console.error("File upload failed for:", file.name, error);
        }
      }

      setSelectedFiles(updatedFiles);
    });

    return false;
  };

  const getFileLastName = (filePath) => {
    if (filePath && typeof filePath === "string" && filePath.includes("/")) {
      return filePath.split("/").pop();
    } else {
      return filePath;
    }
  };

  const highlightTextInHtml = (html, highlight) => {
    if (!highlight.trim()) return html;

    const regex = new RegExp(`(${highlight})`, "gi");
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    const walker = document.createTreeWalker(tempDiv, NodeFilter.SHOW_TEXT, null, false);
    let node;
    while ((node = walker.nextNode())) {
      const text = node.textContent;
      if (regex.test(text)) {
        const span = document.createElement("span");
        span.innerHTML = text.replace(regex, (match) => `<span class="bg-yellow-300">${match}</span>`);
        node.replaceWith(span);
      }
    }

    return tempDiv.innerHTML;
  };

  const filteredNotes = notesData?.notes?.filter(
    (note) =>
      note.notes_title?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      note.notes_body?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      note.created_by?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      note.category_name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      note.updated_by?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const handlePinClick = (e, note) => {
    e.stopPropagation();
    handlePinned(note);
  };
  const PararagraphComponent = ({ CategoryData, searchTerm }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [showReadMore, setShowReadMore] = useState(false);
    const paragraphRef = useRef(null);

    const cleanHtmlContent = (html) => {
      if (!html) return "";
      // Replace <br> tags with spaces while preserving other HTML
      return html.replace(/<br\s*\/?>/gi, " ");
    };

    useLayoutEffect(() => {
      const checkHeight = () => {
        if (paragraphRef.current) {
          const lineHeight = parseInt(window.getComputedStyle(paragraphRef.current).lineHeight);
          const height = paragraphRef.current.scrollHeight;
          const maxHeight = lineHeight * 6;
          setShowReadMore(height > maxHeight);
        }
      };

      checkHeight();

      const resizeObserver = new ResizeObserver(checkHeight);
      if (paragraphRef.current) {
        resizeObserver.observe(paragraphRef.current);
      }

      return () => {
        if (paragraphRef.current) {
          resizeObserver.unobserve(paragraphRef.current);
        }
        resizeObserver.disconnect();
      };
    }, [CategoryData]);
    const handleReadMoreClick = (e) => {
      e.stopPropagation();
      setIsExpanded(!isExpanded);
    };

    // console.log("CategoryData Notes", cleanHtmlContent(CategoryData));

    return (
      <div className="space-y-2 w-full overflow-hidden pr-2">
        <div
          role="textbox"
          ref={paragraphRef}
          className={`w-full text-sm  text-justify text-[#383838] font-500 break-words ${
            isExpanded ? "" : "line-clamp-6"
          }`}
          dangerouslySetInnerHTML={{
            __html: highlightTextInHtml(CategoryData, searchTerm),
          }}
        ></div>

        {showReadMore && (
          <button
            className="text-blue-500 hover:text-blue-600 font-300 text-xs cursor-pointer"
            onClick={(e) => handleReadMoreClick(e)}
          >
            {isExpanded ? "Read less" : "Read more"}
          </button>
        )}
      </div>
    );
  };

  // Helper to convert hex to rgba
  function hexToRgba(hex, alpha = 0.4) {
    let c = hex?.replace("#", "");
    if (c?.length === 3)
      c = c
        .split("")
        .map((x) => x + x)
        .join("");
    const num = parseInt(c, 16);
    return `rgba(${(num >> 16) & 255}, ${(num >> 8) & 255}, ${num & 255}, ${alpha})`;
  }

  return (
    <LoaderWrapper isLoading={showLoaderInBox}>
      {notesData?.notes?.length > 0 ? (
        filteredNotes?.length > 0 ? (
          filteredNotes?.map((note, idx) => (
            <div
              className={editNoteId !== note?.id && `mb-1 pb-0 p-4 rounded-md bg-white group`}
              // style={
              //   editNoteId === note?.id
              //     ? {}
              //     : idx % 2 === 0
              //       ? { borderLeft: `4px solid ${getHexWithOpacity(note?.colour_code, 40)}` }
              //       : { borderRight: `4px solid ${getHexWithOpacity(note?.colour_code, 40)}` }

              // }
              key={note?.id}
              id={`note-${note?.id}`}
            >
              <div className="flex text-sm border-b border-dashed border-[#D2DAE1]">
                <i className={`${note?.notesimg} text-556080 text-3xl `}></i>
                <div className="w-full">
                  {editNoteId === note?.id && viewNotes?.addnotes ? (
                    <div>
                      <Dialog open={notesBody} onClose={hndleCloseNotes} maxWidth="md">
                        <AddEditNotesData
                          setNotesSetting={setViewNotes}
                          notesSetting={viewNotes?.addnotes}
                          visible={viewNotes?.addnotes}
                          handleNotesClick={handleNotesClick}
                          textareaRef={textareaRef}
                          notesTitle={note?.notes_title}
                          notesId={note?.id}
                          notesCategory={note?.category_name}
                          onDataFetch={setNotesData}
                          colourCodes={note?.colour_code}
                          selectedFile={selectedFiles}
                          resetFile={resetFile}
                          customerTaskCategory={customerTaskCategory}
                          customerColor={customerColor}
                          handleSubmit={(e) => handleSubmit(e, note)}
                          handleInputChange={handleInputChange}
                          formData={formData}
                          handleSetColour={handleSetColour}
                          editNoteId={editNoteId}
                          notesBody={note?.notes_body}
                          initialContent={note?.notes_body}
                          handleFileUpload={handleFileUpload}
                          downloadFiles={downloadFile}
                          handleDeleteFileServer={handleDeleteFileServer}
                          handleClickDeleteFile={handleClickDeleteFile}
                          hndleCloseNotes={hndleCloseNotes}
                          key={selectedFiles?.length}
                          getFileLastName={getFileLastName}
                          selectedOptions={selectedOptions}
                          setSelectedOptions={setSelectedOptions}
                        />
                      </Dialog>
                    </div>
                  ) : (
                    <div>
                      <div
                        className={`flex justify-between items-center rounded-md overflow-hidden py-1 px-3 ${editNoteId === note?.id ? "hidden" : "visible"}`}
                        style={
                          editNoteId === note?.id
                            ? {}
                            : idx % 2 === 0
                              ? { backgroundColor: getHexWithOpacity(note?.colour_code, 15) }
                              : { backgroundColor: getHexWithOpacity(note?.colour_code, 15) }
                        }
                      >
                        <div className="flex flex-row gap-x-3 items-center min-w-0 grow">
                          <AvatarName
                            name={getInitials(note?.created_by)}
                            size="medium"
                            bgColor={"#e8ecf299"}
                            textColor={note?.colour_code}
                            borderColor={note?.colour_code}
                          />

                          <div className="min-w-0 grow flex flex-col items-start justify-center  truncate">
                            <div
                              className=" font-600  text-base truncate w-full"
                              style={{ color: note?.colour_code }}
                              dangerouslySetInnerHTML={{
                                __html: highlightTextInHtml(note?.notes_title, searchTerm),
                              }}
                            ></div>
                            <div className="flex items-center justify-center gap-x-2">
                              <div className="text-[#767676] text-xs 0 capitalize  font-normal">{note?.created_by}</div>
                              <span className="h-3 w-[1px] bg-[#767676]"></span>

                              <div className="text-[#767676] text-xs font-normal capitalize">
                                {getFormatDate(note?.created_at)}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="flex items-center gap-1 w-fit ">
                          {disable === true && visible === true && (
                            <Fragment>
                              <button
                                type="button"
                                className="mx-1 opacity-0 group-hover:opacity-100 transition-opacity"
                                onClick={() =>
                                  handleNotesEdit(
                                    note?.id,
                                    note?.notes_body,
                                    note?.attachments,
                                    note?.notes_title,
                                    note?.category_name,
                                    note?.tags
                                  )
                                }
                              >
                                <EditSolidicon className="fill-[#8E8E8E] hover:fill-black" />
                              </button>
                            </Fragment>
                          )}

                          <button
                            type="button"
                            className="mx-2 opacity-0 group-hover:opacity-100 transition-opacity"
                            onClick={() => handleDeleteConfirmation(note)}
                          >
                            <DeleteSolidicon />
                          </button>
                          <div className="flex gap-x-2 items-center w-4 h-6 ">
                            <span
                              onClick={(e) => handlePinClick(e, note)}
                              className="opacity-0 group-hover:opacity-100 transition-opacity"
                            >
                              <LatestPinUnpin
                                className={`cursor-pointer ${
                                  Boolean(note?.is_pinned)
                                    ? "fill-[#00BA00] group-hover:fill-[#30a930]"
                                    : "fill-[#8E8E8E] hover:fill-black"
                                }`}
                              />
                            </span>
                          </div>
                          {/* <div
                            className="opacity-0 group-hover:opacity-100 transition-opacity ml-1"
                          >
                            <Share className="cursor-pointer fill-[#8E8E8E] hover:fill-black" />
                          </div> */}

                          {false && (
                            <div className="border border-[rgba(44, 73, 93, 0.20)] rounded-md p-1 px-2 text-2C495D">
                              <span
                                // className={note?.category_name ? "me-3" : ""}
                                dangerouslySetInnerHTML={{
                                  __html: highlightTextInHtml(note?.category_name, searchTerm),
                                }}
                              ></span>
                              {/* <i className="bi bi-circle-fill" style={{ color: note?.colour_code || "#000" }}></i> */}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="py-2 noteViewPad ml-4 flex flex-col items-start justify-centre gap-y-2">
                        <PararagraphComponent CategoryData={note?.notes_body} searchTerm={searchTerm} />
                        <div className="flex flex-wrap items-center gap-x-2">
                          {note?.tags?.map((option) => {
                            return (
                              <span
                                key={option?.value}
                                className="text-white text-xs font-medium px-2 py-1 rounded items-center"
                                style={{
                                  backgroundColor: getHexWithOpacity(option?.color_code, 10) || "#666",
                                  color: option?.color_code,
                                  border: `1px solid ${option?.color_code}`,
                                }}
                              >
                                {option?.label}
                                {/* <button type="button" className="ml-2 text-white">
                                  <i className="bi bi-x"></i>
                                </button> */}
                              </span>
                            );
                          })}
                        </div>
                        <div className="text-xs flex flex-wrap">
                          {note?.attachments &&
                            note?.attachments.map((attachment) => (
                              <div key={attachment.id} className="flex items-start space-x-2 border p-2 rounded h-9">
                                {/* <span className="truncate">{getFileLastName(attachment.file_name)}</span> */}
                                <span className="truncate">{attachment.file_name}</span>
                                <button
                                  className="text-blue-500 hover:text-blue-700"
                                  onClick={() => downloadFile(attachment.view_url)}
                                >
                                  <i className="bi bi-eye text-14"></i>
                                </button>
                                <button
                                  className="text-blue-500 hover:text-blue-700"
                                  onClick={() => downloadFile(attachment.download_url)}
                                >
                                  <i className="bi bi-download text-12"></i>
                                </button>
                              </div>
                            ))}
                        </div>

                        {/* Uncomment for task Create in Notes */}

                        <div className="flex w-full items-center">
                          <div className="relative flex w-8 h-9 items-center justify-center rounded-md" key={note.id}>
                            {/* Invisible checkbox (full click area) */}
                            <input
                              type="checkbox"
                              className="
      absolute inset-0
      h-full w-full
      appearance-none
      bg-transparent
      border-0
      outline-none
      ring-0
      focus:outline-none
      focus-visible:outline-none
      focus:ring-0
      focus-visible:ring-0
      focus:ring-offset-0
      focus:border-0
      active:outline-none
      active:ring-0
      shadow-none
      cursor-pointer
      z-0
      group
    "
                              id={`to-do-add-data-${note.id}`}
                              name="to_do_add_data"
                              checked={isAddToDoChecked === note.id}
                              onChange={(e) => {
                                handleCheckboxAdd(note.id, e.target.checked);
                                e.target.blur();
                              }}
                            />

                            {/* Centered icon */}
                            <ToolTipComponent title="Add Task" darkMode>
                              <div
                                className={`absolute inset-0 flex items-center justify-center pointer-events-none z-100 bg-[#e9edf070] group-hover:bg-primary-active rounded-l-md`}
                              >
                                <AddNotesTask />
                              </div>
                            </ToolTipComponent>
                          </div>

                          <div className="flex w-full justify-between  items-center px-2 rounded-r-md pr-4 bg-[#e9edf070] ">
                            {isAddToDoChecked == note.id && (
                              <div className="flex items-center px-3 gap-4 ">
                                <div
                                  className={`flex items-center gap-2  rounded-md ${note.id === isAddToDoChecked ? "opacity-100 bg-[#e9edf070]" : "opacity-70 cursor-not-allowed"}`}
                                >
                                  <input
                                    type="checkbox"
                                    className=" h-4 w-4 rounded border-gray-400 bg-white text-[#2999BC] focus:ring-0 focus:outline-none cursor-pointer"
                                    id="to-do-data"
                                    name="to_do_data"
                                    onChange={(e) => handleCheckboxChange(e, note.id)}
                                    checked={note.id === isAddToDoChecked}
                                  />
                                  <div className="flex items-center text-[#383838] font-normal text-sm">
                                    My Activites -
                                    <div className="relative w-fit ">
                                      <div
                                        className="text-[#1D4469] text-sm font-medium whitespace-nowrap  flex items-center gap-1 bg-white px-2 py-0.5 rounded-md"
                                        ref={note.id === isAddToDoChecked ? to_doRef : null}
                                      >
                                        <div className="flex items-center gap-2 ">
                                          <span className="text-[#1D4469] font-medium">
                                            {getTitleCase(selectedContent)}
                                          </span>
                                          <div
                                            className={` ${note.id === isAddToDoChecked ? "cursor-pointer" : "cursor-not-allowed"}`}
                                            onClick={() => {
                                              if (!note.id === isAddToDoChecked) return; // Prevent action if checkbox is not checked
                                              setShowViewList((prev) => !prev);
                                            }}
                                          >
                                            <DownArrow
                                              fill={
                                                note.id === isAddToDoChecked && showViewList ? "#383838" : "#383838"
                                              }
                                              className={`transition-transform duration-200 h-3 w-3 rounded-sm  ${note.id === isAddToDoChecked && showViewList ? "rotate-180 " : "rotate-0 "}`}
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      {note.id === isAddToDoChecked && showViewList && (
                                        <div className="absolute  mt-1  bg-white shadow border rounded-md ">
                                          <PortalList
                                            open={showViewList}
                                            onClose={() => setShowViewList(false)}
                                            containerRef={note.id === isAddToDoChecked ? to_doRef : null}
                                            options={TaskToDoData}
                                            selectedOptions={[
                                              TaskToDoData.find((opt) => opt.value === selectedContent),
                                            ]}
                                            setSelectedOptions={(selected) => setSelectedContent(selected[0]?.value)}
                                            onOptionClick={(selected) => handleSelectContent(selected[0])}
                                            size="medium"
                                            name="TaskToDoData"
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  <div className="flex items-center text-[#383838] text-sm font-normal">
                                    for
                                    <div className="relative ml-2">
                                      <div
                                        className=" py-1 flex items-center justify-center border border-transparent  h-full rounded-md"
                                        ref={note.id === isAddToDoChecked ? dateRef : null}
                                      >
                                        <span className=" whitespace-nowrap flex items-center gap-2 bg-white px-2 py-0.5 rounded-md">
                                          <span className="text-[#1D4469]  font-medium ">
                                            {/* {selectedDateOption?.label || DaysToFollowUp.find((item) => item.value === selectedDate).label} */}
                                            {selectedDateOption?.label || selectedDate}
                                          </span>
                                          <div
                                            className={` ${note.id === isAddToDoChecked ? "cursor-pointer" : "cursor-not-allowed"}`}
                                            onClick={() => {
                                              if (!note.id === isAddToDoChecked) return; // Prevent action if checkbox is not checked
                                              setDateViewContent((prev) => !prev);
                                              setIsCustomDateView(false); // close date picker
                                            }}
                                          >
                                            <DownArrow
                                              fill={
                                                note.id === isAddToDoChecked && DateViewContent ? "#383838" : "#383838"
                                              }
                                              className={`transition-transform duration-200 h-3 w-3 ${note.id === isAddToDoChecked && DateViewContent ? "rotate-180" : "rotate-0"}`}
                                            />
                                          </div>
                                        </span>
                                      </div>

                                      <div>
                                        {note.id === isAddToDoChecked && DateViewContent && (
                                          <div className="absolute top-full mt-1  shadow border rounded-md z-10">
                                            <PortalList
                                              open={DateViewContent}
                                              onClose={() => setDateViewContent(false)}
                                              containerRef={note.id === isAddToDoChecked ? dateRef : null}
                                              options={DaysToFollowUp}
                                              selectedOptions={[
                                                DaysToFollowUp.find((item) => item.value === selectedDate),
                                              ]}
                                              setSelectedOptions={(selected) => setSelectedDate(selected[0]?.value)}
                                              onOptionClick={(selected) => {
                                                handleSelectDate(selected[0]);
                                                setDateViewContent(false);
                                              }}
                                              size="medium"
                                              name="dateContent"
                                              addButton
                                              addButtonLabel="Custom Date"
                                              addButtonAction={handleCustomViewClick}
                                            />
                                          </div>
                                        )}

                                        {isCustomDateView && note.id === isAddToDoChecked && (
                                          <div className="">
                                            <DatePickerComponent
                                              dateFormat="dd MMM yyyy"
                                              placeholderText="DD MM YYYY"
                                              showYearDropdown
                                              autoOpen
                                              showMonthDropdown
                                              scrollableYearDropdown
                                              border="hidden"
                                              onChange={handleDateChange}
                                              boxHidden={true}
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <button
                                  onClick={() => {
                                    if (!note.id === isAddToDoChecked) return;
                                    handleCheckboxAdd(note.id, false);
                                    handleCreateTask(note);
                                  }}
                                  className={`bg-primary text-white px-2 mx-2 py-0.5 rounded-md ${note.id === isAddToDoChecked ? "opacity-100" : "opacity-70 cursor-not-allowed"}`}
                                >
                                  Save
                                </button>
                              </div>
                            )}

                            <div className="flex justify-end min-w-0 grow  py-2">
                              {note?.updated_by && note?.updated_at && (
                                <span>
                                  <span className="text-[#007296] font-medium text-xs">Last Updated:</span>
                                  <span className="text-[#007296] text-xs"> {note?.updated_by} </span>
                                  <span className="text-[#007296] text-xs"> | {getUserDateTime(note?.updated_at)}</span>
                                </span>
                              )}

                              {/* Uncomment for Link */}
                              {/* <div className={`flex ${isCreateTask ? "opacity-100" : "opacity-70 cursor-not-allowed"}`}>
                              <div className="relative ml-2">
                                <div
                                  className="py-1 flex items-center justify-center border border-transparent h-full rounded-md"
                                  ref={listRef}
                                >
                                  <span className="whitespace-nowrap flex items-center gap-2 bg-white px-2 py-0.5 rounded-md">
                                    <span className="text-[#1D4469] font-medium">Link ({selectedList.length})</span>
 
                                    <div
                                      className={`${isCreateTask ? "cursor-pointer" : "cursor-not-allowed"}`}
                                      onClick={() => {
                                        if (!isCreateTask) return;
                                        setListViewContent((prev) => !prev);
                                      }}
                                    >
                                      <DownArrow
                                        fill="#383838"
                                        className={`transition-transform duration-200 h-3 w-3 ${
                                          isCreateTask && ListViewContent ? "rotate-180" : "rotate-0"
                                        }`}
                                      />
                                    </div>
                                  </span>
                                </div>
 
                                {ListViewContent && (
                                  <div className="absolute top-full mt-1 shadow border rounded-md z-10">
                                    <PortalList
                                      xAxis={-190}
                                      showSearch
                                      open={ListViewContent}
                                      onClose={() => setListViewContent(false)}
                                      containerRef={listRef}
                                      options={OptionData}
                                      selectedOptions={OptionData.filter((item) => selectedList.includes(item.value))}
                                      setSelectedOptions={(selected) => {
                                        const values = selected.map((item) => item.value);
                                        setSelectedList(values);
                                      }}
                                      onOptionClick={(selected) => {
                                        const values = selected.map((item) => item.value);
                                        setSelectedList(values); //  Always update here
                                      }}
                                      multiSelect
                                      size="medium"
                                      name="listContent"
                                      show
                                    />
                                  </div>
                                )}
                              </div>
                            </div> */}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* uncomment for Task Create in notes */}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="h-[calc(100vh-160px)]">
            <div className="flex justify-center items-center flex-col space-y-2 h-full ">
              <NoNotesIcon />
              {/* <span className="text-14 text-black text-sm font-400">No Notes is Available.</span> */}
              <span
                // onClick={handleAddNotes}
                className="border px-5 py-1.5   cursor-pointer items-center text-center text-sm font-400  hover:border-[#1D4469] hover:text-[#1D4469] text-[#383838] rounded-3xl shadow-[0px_1px_0px_0px_rgba(0,0,0,0.10)_inset,0px_0px_4px_0px_rgba(0,0,0,0.15)]"
              >
                No matching notes found.
              </span>
            </div>
          </div>
        )
      ) : (
        <div className="h-full w-full flex items-center justify-center">
          <div className="flex justify-center items-center flex-col space-y-2 h-full ">
            <NoNotesIcon className="w-[300px] h-[300px]" />
            <span className="text-14 flex flex-col items-center text-black text-sm font-400">
              {showLoaderInBox ? "Fetching Notes Data" : "No Note Available."}
              {!disableAddMode && (
                <Button onClick={() => handleAddNotesClick()} className="py-1 px-3 w-fit">
                  {" "}
                  + Add Note{" "}
                </Button>
              )}
            </span>
            {/* <span
              onClick={handleNotes}
              className="border px-5 py-1.5   cursor-pointer items-center text-center text-sm font-400  hover:border-[#1D4469] hover:text-[#1D4469] text-[#383838] rounded-3xl shadow-[0px_1px_0px_0px_rgba(0,0,0,0.10)_inset,0px_0px_4px_0px_rgba(0,0,0,0.15)]"
            >
              + Add Note
            </span> */}
          </div>
        </div>
      )}

      {showConfirmation && (
        <ConfirmationDialog
          open={showConfirmation}
          onConfirm={() => handleDelete(deleteNotesData)}
          onClose={() => setShowConfirmation(false)}
          title="Delete"
          // message={
          //   <>
          //     Are you sure you want to delete <br /><span className="font-medium text-center">note</span> - <span className="font-medium">{showConfirmation}</span> ?
          //   </>
          // }
          message={"This note will be permanently deleted and cannot be recovered. Do you want to delete ?"}
          confirmVariant="delete"
          iconVariant="delete"
          confirmText="Delete"
          cancelText="Cancel"
        />
      )}
    </LoaderWrapper>
  );
};
export default AllNotesShow;
